import { Component, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { LoadingService } from '../../../services';
import { AlertService } from '../../../services/alert/alert.service';
import { ChatBotV2DataService } from '../../../services/chat-bot-v2/chat-bot-v2.data.service';
import { ChatBotV2Service } from '../../../services/chat-bot-v2/chat-bot-v2.service';
import { LayoutService } from '../../../services/layout/layout.service';
import { ChatBotAsesorV2BorrarChatComponent } from '../chat-bot-asesor-v2-borrar-chat/chat-bot-asesor-v2-borrar-chat.component';

@Component({
  selector: 'app-chat-bot-asesor-v2-sidenav',
  templateUrl: './chat-bot-asesor-v2-sidenav.component.html',
  styleUrls: ['./chat-bot-asesor-v2-sidenav.component.scss'],
})
export class ChatBotAsesorV2SidenavComponent {
  constructor(
    public chatBotV2DS: ChatBotV2DataService,
    private chatBotV2S: ChatBotV2Service,
    private alertS: AlertService,
    private loadingS: LoadingService,
    private dialog: MatDialog,
    layoutS: LayoutService,
    el: ElementRef
  ) {
    layoutS.addComponentHeight(el, 'menu-right');
  }

  irChat() {
    this.chatBotV2DS.sessionID = this.chatBotV2DS.selectRow.idSession;
    this.chatBotV2DS.sidenav = false;
    this.chatBotV2DS.tabActive.next(0);
  }

  async eliminarChat() {
    try {
      const borrar = await this.getDebeBorrar();
      if (!borrar) return;
      this.loadingS.showLoading();
      await this.chatBotV2S.eliminarSesion(this.chatBotV2DS.selectRow.idSession);
      this.loadingS.hideLoading();
      this.chatBotV2DS.sidenav = false;
      this.alertS.showSnackBarTopRight({
        titulo: 'Borrado',
        mensaje: 'Has borrado el chat del historial correctamente.',
        severity: 'success',
        enFila: true
      });
      this.chatBotV2DS.recargarDashboard.next();
    } catch (error) {
      this.chatBotV2DS.sidenav = false;
      this.alertS.showSnackBarTopRight({
        titulo: 'Error',
        mensaje: 'El servicio ha fallado, inténtalo de nuevo más tarde.',
        severity: 'error',
        enFila: true
      });
      this.loadingS.hideLoading();
    }
  }

  private getDebeBorrar() {
    return this.dialog.open(
      ChatBotAsesorV2BorrarChatComponent,
      {
        disableClose: true,
        hasBackdrop: true,
        autoFocus: false,
        maxWidth: '600px',
        panelClass: 'sura'
      }
    ).afterClosed().pipe(map(resp => !!resp)).toPromise()
  }

}
